import script from "./DocumentUploadWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentUploadWidget.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentUploadWidget.vue?vue&type=style&index=0&id=4f453d10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f453d10"]])

export default __exports__